import React from "react"

import { Content, IconButton } from './styles'

import { FiChevronRight } from "react-icons/fi";

function Button({ link, text }) {

  return (
    <Content className="button" to={link} >
      {text}
      <IconButton>
        <FiChevronRight strokeWidth='4px' size="1.5rem" />
      </IconButton>
    </Content>
  )
}

export default Button
